<div class="item">
  <span class="thin">Status</span>
  <campaign-status-badge [campaignStatus]="campaignStatus"></campaign-status-badge>
</div>
